import { Delete, Pencil } from '@factorialco/f0-react/icons/app'
import { GoalsValueObjectsMetricProgressAssessmentProgressStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

type StatusConfig = {
  variant: 'positive' | 'warning' | 'neutral' | 'info'
  label: string
}

export function getStatusConfig(
  status: GoalsValueObjectsMetricProgressAssessmentProgressStatusEnum
): StatusConfig | null {
  switch (status) {
    case 'achieved':
      return {
        variant: 'positive',
        label: i18n.t('performance_goals.metric_assessment_status_tag.achieved'),
      }
    case 'over_achieved':
      return {
        variant: 'positive',
        label: i18n.t('performance_goals.metric_assessment_status_tag.over_achieved'),
      }
    case 'at_risk':
    case 'highly_at_risk':
      return {
        variant: 'warning',
        label: i18n.t('performance_goals.metric_assessment_status_tag.needs_attention'),
      }
    case 'not_achieved':
      return {
        variant: 'neutral',
        label: i18n.t('performance_goals.metric_assessment_status_tag.not_achieved'),
      }
    case 'on_track':
      return {
        variant: 'info',
        label: i18n.t('goals_revamp.detail.status_in_progress'),
      }
    default:
      return null
  }
}

interface DropdownActions {
  canEdit: boolean | undefined
  canDelete: boolean | undefined
  onEdit: () => void
  onDelete: () => void
}

export function buildDropdownItems({ canEdit, canDelete, onEdit, onDelete }: DropdownActions) {
  const items: { label: string; icon?: typeof Pencil; onClick: () => void; critical?: boolean }[] = []

  if (canEdit) {
    items.push({
      label: i18n.t('common.edit'),
      icon: Pencil,
      onClick: onEdit,
    })
  }

  if (canDelete) {
    items.push({
      label: i18n.t('performance_goals.metric_row.delete'),
      icon: Delete,
      onClick: onDelete,
      critical: true,
    })
  }

  return items
}
